import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { ExecForecast } from '../components/widgets/ExecForecast';

export default function ExecForecastPage() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="תחזית קיבולת" />
        <main className="flex-1 overflow-y-auto p-6">
          <ExecForecast />
        </main>
      </div>
    </div>
  );
}
